const isEmptyLastTierCommission = (params) => {
	const { tiers } = params || {};
	const rows = tiers?.length || 0;
	const columns = tiers?.[0]?.commissions?.length || 0;
	const { commission } = tiers?.[rows - 1]?.commissions?.[columns - 1] || {};
	return !commission?.value;
};

const isProductDefined = (params) => {
	const { products } = params || {};
	return Boolean(products?.length);
};

export { isEmptyLastTierCommission, isProductDefined };
